import React, { useState } from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import moment from 'moment';
import { checkPermission } from '../../../../utils_v2';
import DeleteIcon from '@material-ui/icons/Delete';
import { displayDateFormatShort } from '../../../../constants';
import NotesCRU from './NotesCRU';

export default function NotesList({item, getResponseBack, contractInfo,deleteSubLease}){
const [showMore, setShowMore] = useState({});
const toggleDescription = (id, field) => {
  setShowMore((prev) => ({
    ...prev,
    [`${id}_${field}`]: !prev[`${id}_${field}`],
  }));
};

  return(
    <>
    <TableRow hover tabIndex={-1}>
      <TableCell>{item?.type}</TableCell>
      <TableCell style={{maxWidth:'400px'}}>
          {item?.description && item?.description?.length > 200 ? (
            <div style={{ maxWidth: '400px' }}>
              {showMore[`${item?.id}_description`] ? (
                <span>
                  <span dangerouslySetInnerHTML={{ __html: item?.description?.replace(/\n/g, '<br />') }} />
                  <a href="#" style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item?.id, 'description'); }} > less </a>
                </span>
              ) : (
                <span>
                  <span dangerouslySetInnerHTML={{ __html: item?.description.substring(0, 190)?.replace(/\n/g, '<br />') }} />
                  <a href="#" style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item?.id, 'description'); }} > ..more </a>
                </span>
              )}
            </div>
          ) : (
            <div>
              <span dangerouslySetInnerHTML={{ __html: item?.description?.replace(/\n/g, '<br />') }} />
            </div>
          )}
      </TableCell>
      <TableCell style={{maxWidth:'400px'}}>
          {item?.remarks && item?.remarks?.length > 200 ? (
            <div style={{ maxWidth: '400px' }}>
              {showMore[`${item?.id}_remarks`] ? (
                <span>
                  <span dangerouslySetInnerHTML={{ __html: item?.remarks?.replace(/\n/g, '<br />') }} />
                  <a href="#" style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item?.id, 'remarks'); }} > less </a>
                </span>
              ) : (
                <span>
                  <span dangerouslySetInnerHTML={{ __html: item?.remarks.substring(0, 190)?.replace(/\n/g, '<br />') }} />
                  <a href="#" style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item?.id, 'remarks'); }} > ..more </a>
                </span>
              )}
            </div>
          ) : (
            <div>
              <span dangerouslySetInnerHTML={{ __html: item?.remarks?.replace(/\n/g, '<br />') }} />
            </div>
          )}
      </TableCell>
      <TableCell>{item?.start_date ? moment(item?.start_date).format(displayDateFormatShort):'--'}</TableCell>
      <TableCell>{item?.end_date ? moment(item?.end_date).format(displayDateFormatShort): '--'}</TableCell>
      <TableCell>
        <NotesCRU getResponseBack={getResponseBack} m="V" id={item.id} contractInfo={contractInfo}/>
        {checkPermission('contracts','lease_notes', 'D') ?<DeleteIcon fontSize='small' color='secondary' style= {{cursor:'pointer'}} onClick={()=>deleteSubLease(item.id)}/>:null}
      </TableCell>
      </TableRow>
    </>
  )
}
